import { createAsyncThunk } from '@reduxjs/toolkit'
import GameConfig from './game-config-model'
import {
  delete_gameConfig,
  load_gameConfigs,
  store_gameConfig,
} from './gameConfig-service'

export const LoadGameConfigsAsync = createAsyncThunk<any, any>(
  'composer/load/gameConfig',
  async (params: { uid: string }) => {
    return await load_gameConfigs(params)
  },
)

export const CreateGameConfigAsync = createAsyncThunk<any, any>(
  'composer/create/gameConfig',
  async (params: GameConfig) => {
    return await store_gameConfig(params)
  },
)

export const DeleteGameConfigAsync = createAsyncThunk<any, any>(
  'composer/delete/gameConfig',
  async (params) => {
    return await delete_gameConfig(params)
  },
)
